var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRadioOnButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    fill: "#424242",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256,469.3c-117.8,0-213.3-95.5-213.3-213.3S138.2,42.7,256,42.7S469.3,138.2,469.3,256S373.8,469.3,256,469.3z M256,426.7 c45.3,0,88.7-18,120.7-50c32-32,50-75.4,50-120.7c0-45.3-18-88.7-50-120.7c-32-32-75.4-50-120.7-50c-45.3,0-88.7,18-120.7,50 c-32,32-50,75.4-50,120.7c0,45.3,18,88.7,50,120.7C167.3,408.7,210.7,426.7,256,426.7z M256,362.7c-28.3,0-55.4-11.2-75.4-31.2 c-20-20-31.2-47.1-31.2-75.4s11.2-55.4,31.2-75.4c20-20,47.1-31.2,75.4-31.2c28.3,0,55.4,11.2,75.4,31.2c20,20,31.2,47.1,31.2,75.4 c0,28.3-11.2,55.4-31.2,75.4C311.4,351.4,284.3,362.7,256,362.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioOnButton);
export default __webpack_public_path__ + "static/media/radio-on-button.e8d29e31d340899d99c383b2980ca478.svg";
export { ForwardRef as ReactComponent };